export default {"src":"/_next/static/media/icon_people.5229bd14.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};